import * as React from 'react';
import { useCallback } from 'react';
import { mergeStyles } from '@fluentui/react/lib/Styling';
import { PhoneField } from '@microsoft/portal-app/lib/PhoneFields/PhoneField';
import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';
import { ContactPreferencePhoneNumberError } from '../models';

export interface IContactPreferencePhoneInputProps {
  disabled?: boolean;
  error?: ContactPreferencePhoneNumberError;
  countryCode?: string;
  subscriberNumber?: string;
  onCountryCodeChange?: (value: string) => void;
  onSubscriberNumberChange?: (value: string) => void;
}

export const ContactPreferencePhoneInput = ({
  disabled = false,
  error,
  countryCode = '1',
  subscriberNumber,
  onCountryCodeChange,
  onSubscriberNumberChange
}: IContactPreferencePhoneInputProps): React.ReactElement | null => {
  const [t, isLocalizationReady] = useLocalization(['Privacy', 'CountryCodes']);
  const className = mergeStyles({ displayName: 'ContactPreferencePhoneInput', width: '100%', maxWidth: '500px' });
  const handleCountryCode = useCallback(
    (ev: React.ChangeEvent<HTMLSelectElement>) => {
      onCountryCodeChange?.(ev.target.value);
    },
    [onCountryCodeChange]
  );
  const handleSubscriberNumber = useCallback(
    (_: any, newValue?: string) => {
      onSubscriberNumberChange?.(newValue ?? '');
    },
    [onSubscriberNumberChange]
  );

  if (!isLocalizationReady) {
    return null;
  }

  return (
    <div className={className}>
      <PhoneField
        t={t}
        countryRegionProps={{
          ariaLabel: t('contactPreferenceCountryCodePlaceholder'),
          disabled,
          selectedKey: countryCode,
          onCountryCodeChange: handleCountryCode
        }}
        phoneProps={{
          placeholder: t('contactPreferencePhonePlaceholder'),
          disabled: disabled,
          errorMessage: error && t(error),
          value: subscriberNumber,
          onChange: handleSubscriberNumber
        }}
      />
    </div>
  );
};
